var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteGeneralInvite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 46.9792H9.16659C6.64575 46.9792 4.58325 44.9167 4.58325 42.3958V18.4479C4.58325 16.9583 5.27075 15.5833 6.53117 14.6667L27.4999 0L48.4687 14.6667C49.7291 15.4688 50.4166 16.9583 50.4166 18.4479V42.3958C50.4166 44.9167 48.3541 46.9792 45.8333 46.9792Z",
    fill: "url(#paint0_linear_6_1069)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 46.9792H9.16659C6.64575 46.9792 4.58325 44.9167 4.58325 42.3958V18.4479C4.58325 16.9583 5.27075 15.5833 6.53117 14.6667L27.4999 0L48.4687 14.6667C49.7291 15.4688 50.4166 16.9583 50.4166 18.4479V42.3958C50.4166 44.9167 48.3541 46.9792 45.8333 46.9792Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 23.375H41.25V46.0625H13.75V23.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0259 35.4062H28.4483V44.4149H27.0259V35.4062Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2327 39.1994H32.2413V40.6218H23.2327V39.1994Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 46.9792H9.16659C6.64575 46.9792 4.58325 44.9167 4.58325 42.3958V19.4792L27.4999 34.375L50.4166 19.4792V42.3958C50.4166 44.9167 48.3541 46.9792 45.8333 46.9792Z",
    fill: "#81B1A9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_1069",
    x1: 14,
    y1: 1.3147e-7,
    x2: 57,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteGeneralInvite);
export default __webpack_public_path__ + "static/media/inviteGeneralInvite.a18e0ea7984a72d7044a525c0f755a72.svg";
export { ForwardRef as ReactComponent };